import { useState } from "react";
import { StripeTruth } from "@/components/StripeTruth";
import { fmtDateTime } from "@/lib/format";

const STATUS_STYLE = { paid: "text-emerald-400", refunded: "text-red-300", abandoned: "text-[#555]" };

const Fulfilment = ({ o }) => {
  if (o.payment_status !== "paid") return <span className="text-[#555]">—</span>;
  if (o.user_id || o.fulfilment === "unlocked") return <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-emerald-400">Unlocked ✓</span>;
  return <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#B45309]">Waiting · not signed up / confirmed</span>;
};

export const AdminOrdersTab = ({ orders, stats, onReload }) => {
  const [showAbandoned, setShowAbandoned] = useState(false);
  const abandoned = orders.filter((o) => o.payment_status === "abandoned").length;
  const visible = orders.filter((o) => showAbandoned || o.payment_status !== "abandoned");

  return (
    <>
      <StripeTruth stats={stats} onReconciled={onReload} />
      <div className="flex items-center justify-between mb-3">
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C]" data-testid="orders-visible-count">
          {visible.length} of {orders.length} checkouts shown
        </div>
        <button onClick={() => setShowAbandoned((v) => !v)} className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] hover:text-[#B45309] transition-colors" data-testid="orders-show-abandoned" aria-pressed={showAbandoned}>
          {showAbandoned ? "Hide abandoned checkouts" : `Show abandoned checkouts (${abandoned})`}
        </button>
      </div>
      <div className="tacc-card overflow-x-auto" data-testid="admin-orders-table">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-left font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] border-b border-[#E7DFD5]">
              <th className="p-4">Date</th><th className="p-4">Product</th><th className="p-4">Amount</th><th className="p-4">Buyer</th><th className="p-4">Status</th><th className="p-4">Unlocked</th>
            </tr>
          </thead>
          <tbody>
            {visible.map((o) => (
              <tr key={o.session_id} className="border-b border-[#E7DFD5] hover:bg-black/5" data-testid={`admin-order-${o.session_id}`}>
                <td className="p-4 text-[#78716C] whitespace-nowrap">{fmtDateTime(o.created_at)}</td>
                <td className="p-4">{o.product_name || o.lookup_key}</td>
                <td className="p-4 text-[#B45309]">${o.amount}</td>
                <td className="p-4 text-[#78716C] text-xs">{o.buyer_email || "—"}</td>
                <td className="p-4">
                  <span className={`font-mono text-[10px] tracking-[0.2em] uppercase ${STATUS_STYLE[o.payment_status] || "text-[#78716C]"}`} data-testid={`admin-order-status-${o.session_id}`}>
                    {o.payment_status === "pending" ? "checkout opened · not paid" : o.payment_status}
                  </span>
                </td>
                <td className="p-4" data-testid={`admin-order-fulfilment-${o.session_id}`}><Fulfilment o={o} /></td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-[#78716C]">No checkouts yet.</td></tr>}
            {orders.length > 0 && visible.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-[#78716C]" data-testid="orders-all-abandoned">Every checkout so far was abandoned — nobody has paid yet. Toggle above to see them.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
